import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { RadioButton } from '@vectord/components';

import {
  setTransactionType,
  transactionTypeSelector,
} from 'features/creditManagement';
import Field from 'components/Field';
import styles from './ManageCreditRadioField.module.scss';

function ManageCreditRadioField() {
  const dispatch = useDispatch();
  const valueType = useSelector(transactionTypeSelector);

  const handleChange = useCallback(
    (event) => {
      dispatch(setTransactionType(event.target.name));
    },
    [dispatch]
  );

  return (
    <Field
      label="Select Credit Type:"
      name="SelectCreditTypeField"
      prefixName="addCreditCountField"
    >
      <div className={classNames(styles.input, 'm-t-xxs')}>
        <RadioButton
          active={valueType === 'ADD'}
          name={'ADD'}
          text="Add Credit"
          textClassName={styles.text}
          onChange={handleChange}
        />
        <RadioButton
          active={valueType === 'DEDUCT'}
          name={'DEDUCT'}
          text="Deduct Credit"
          textClassName={styles.text}
          onChange={handleChange}
        />
      </div>
    </Field>
  );
}

export default ManageCreditRadioField;
